import React, { useState,useEffect } from "react";
// import Input from '../../Components/Atoms/Input/Input'
import {
  
  FormDropdown,
  FormField,
   
} from "../../Components/Molecules/FormField/FormField";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../../Helpers/thousandSeparator";
import {
  
  PrimaryButton
} from "../../Components/Atoms/Button/Button";
import HBar from "../../Components/Bars/Bars";
import _ from "lodash"
import { get_master_data} from "../../Enums/api_constunts"
import { postMethod } from "../../Helpers/services";

export const SalariedComponent = ({ formik, HBarLabel,loanFormDetails,setTotalSalaryNetIncome ,setTotalOtherIncome,calculateSpendingPercentage }) => {
    const otherIncomeOptions = [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ];
    const [other_income_list, setIncomeFields] = useState([ { incomeType: "", amount: "" }]);

  const handleAddIncomeField = () => {
    setIncomeFields([...other_income_list, { incomeType: "", amount: "" }]);
  };

  const handleRemoveIncomeField = (index) => {
    const updatedFields = other_income_list.filter((_, i) => i !== index);
    setIncomeFields(updatedFields);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = other_income_list.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setIncomeFields(updatedFields);
    formik.setFieldValue(`other_income_list[${index}].${field}`, value);
  };

  const handleChange = (e ,type="grossSalary") => {
    const rawValue = e.target.value.replace(/,/g, "");
    const formattedValue = thosuandSeparator(rawValue);
    formik.setFieldValue(type, e.target.value);
  };
  const updateTotalOtherIncomeAmount = ()=>{
    console.log(JSON.stringify(formik.values))
    let amount = 0;
   
    other_income_list.forEach((item)=>{
      console.log(_.get(item,"incomeType",""))
      if(_.get(item,"amount",0) && _.get(item,"incomeType","").trim() !='' ){
        
        amount =amount+parseInt(item["amount"])
      } })
  
     setTotalOtherIncome(amount)    
     formik.setFieldValue("total_other_income_per_month",amount)
     
    //  if(_.has(formik, "values.netSalary")){
    //   let netSalary =  parseFloat(formik.values.netSalary);
    //   formik.setFieldValue("total_income_per_month",amount+netSalary);

    //  }
     


  }
  useEffect(()=>{
    if(_.get(loanFormDetails,"other_income_list","")){
      try{
        //otherIncome
        const dbother_income_list = JSON.parse(loanFormDetails["other_income_list"]);
        
        if(_.get(dbother_income_list,"length")>0){
          let items = []
          dbother_income_list.forEach((item,index)=>{
            formik.setFieldValue(`other_income_list[${index}].incomeType`, item["incomeType"]);
            formik.setFieldValue(`other_income_list[${index}].amount`, item["amount"]); 
            //formik.values["other_income_lis"][index]["incomeType"] = item["incomeType"]
            items.push(item)
          });
          
          setIncomeFields(items)

        }else{
          setIncomeFields([ { incomeType: "", amount: "" }])
        }
        
      }catch(error){
        setIncomeFields([ { incomeType: "", amount: "" }])
      }

    }else{
      setIncomeFields([ { incomeType: "", amount: "" }])
    }

  },[loanFormDetails])
  useEffect(()=>{
    updateTotalOtherIncomeAmount()

  },other_income_list)

  const [otherIncomeTypeOptions, setOtherIncomeTypeOptions] =useState([])
  const getMasterData = (category='')=>{
    let postData = {"categories":["md_other_income_types"]};
    
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
      if(category=="md_other_income_types"){  
        
        setOtherIncomeTypeOptions( _.get(res,"result.md_other_income_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      }
        
      })
  }
  useEffect(()=>{
    getMasterData("md_other_income_types")
  },[])
  return (
    <div>
      {HBarLabel && <HBar label={HBarLabel} />}
      <div className="row">
        <div className="col-md-4 mb-2">
          <FormField
            label="Company Name"
            id="companyName"
            name="companyName"
            type="text"
            value={formik?.values?.companyName}
            onChange={(e) =>
              formik.setFieldValue("companyName", e.target.value)
            }
            error={formik.touched.companyName && formik.errors.companyName}
            disableNumbers={true}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.companyName && <ErrorLabel
            name="companyName"
            formik={formik}
            message={formik.errors.companyName}
          />}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Designation"
            id="designation"
            name="designation"
            type="text"
            value={formik?.values?.designation}
            onChange={(e) =>
              formik.setFieldValue("designation", e.target.value)
            }
            error={formik.touched.designation && formik.errors.designation}
            disableNumbers={true}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.designation && <ErrorLabel
            name="designation"
            formik={formik}
            message={formik.errors.designation}
          />}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Total Experience"
            id="totalExperience"
            name="totalExperience"
            type="text"
            value={formik?.values?.totalExperience}
            onChange={(e) =>
              formik.setFieldValue("totalExperience", e.target.value)
            }
            error={
              formik.touched.totalExperience && formik.errors.totalExperience
            }
            disableNumbers={false}
            disableSymbols={false}
            disableAlphebets={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.totalExperience && <ErrorLabel
            name="totalExperience"
            formik={formik}
            message={formik.errors.totalExperience}
          />}
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-2">
          <FormField
            label="Years in Current Organization"
            id="present_organization_years"
            name="present_organization_years"
            type="text"
            value={formik?.values?.present_organization_years}
            onChange={(e) =>{

                formik.setFieldValue("present_organization_years", e.target.value)
              
            }
             
            }
            error={
              formik.touched.present_organization_years &&
              formik.errors.present_organization_years
            }
            disableNumbers={false}
            disableSymbols={false}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.present_organization_years && <ErrorLabel
            name="present_organization_years"
            formik={formik}
            message={formik.errors.present_organization_years}
          />}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Work Location"
            id="workLocation"
            name="workLocation"
            type="text"
            value={formik?.values?.workLocation}
            onChange={(e) =>
              formik.setFieldValue("workLocation", e.target.value)
            }
            error={formik.touched.workLocation && formik.errors.workLocation}
            disableNumbers={true}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.workLocation && <ErrorLabel
            name="workLocation"
            formik={formik}
            message={formik.errors.workLocation}
          />}
        </div>
        <div className="col-md-4 mb-2">
          
          <FormField
            label="Gross Salary (Per Month)"
            id="grossSalary"
            name="grossSalary"
            type="text"
            value={formik?.values?.grossSalary}
            onChange={(e) => handleChange(e,"grossSalary")}
            error={formik.touched.grossSalary && formik.errors.grossSalary}
            disableNumbers={false}
            disableSymbols={true}
            disableAlphebets={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.grossSalary && <ErrorLabel
            name="grossSalary"
            formik={formik}
            message={formik.errors.grossSalary}
          />}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Net Salary (Per Month)"
            id="netSalary"
            name="netSalary"
            type="text"
            value={formik?.values?.netSalary}
            onChange={(e) =>{ 
              
              
              setTotalSalaryNetIncome(e.target.value)
              handleChange(e,"netSalary")
              
            } }
            error={formik.touched.netSalary && formik.errors.netSalary}
            disableNumbers={false}
            disableSymbols={true}
            disableAlphebets={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.netSalary && <ErrorLabel
            name="netSalary"
            formik={formik}
            message={formik.errors.netSalary}
          />}
        </div>
        
      </div>
     
       
       {/* <div className="row">
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="Obligations"
            id="Obligations"
            name="Obligations"
            options={otherIncomeOptions}
            onChange={(selected) => {
              console.log("selected", selected);
              
              formik.setFieldValue("Obligations", selected?.label);
              if(selected?.label=="No"){
                formik.setFieldValue("obligations_per_month",0)
              }
              setTimeout(()=>{
                calculateSpendingPercentage()
              },100)
              
            }}
            value={formik.values.Obligations}
            error={formik.touched.Obligations && formik.errors.Obligations}
            onBlur={formik.handleBlur}
          />
          <ErrorLabel
            name="Obligations"
            formik={formik}
            message={formik.errors.Obligations}
          />
        </div>
        </div>
        <div className="row">
        {formik.values.Obligations === "Yes" && (
          <div className="col-md-4 mb-2">
            <FormField
              label="Total Obligations per Month"
              id="obligations_per_month"
              name="obligations_per_month"
              onChange={(e) => {
                
                //formik.setFieldValue("obligations_per_month", selected?.label);
              }}
              value={formik.values.obligations_per_month}
              error={formik.touched.obligations_per_month && formik.errors.obligations_per_month}
              onBlur={formik.handleBlur}
              disableAlphebets={true}
              disableSymbols={true}
              readOnly
            />
            <ErrorLabel
              name="obligations_per_month"
              formik={formik}
              message={formik.errors.obligations_per_month}
            />
          </div>
        )}
      </div> */}
      
    </div>
  );
};